const getters = {
    getScrollProgressByUid:(state) => (uid) => {
        const instance = state.currentScrollTriggers.find(instance => instance.uid === uid)
        return instance.progress
    }
};

export default getters;